"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearProcessingRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.ClearProcessingRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    counterId: (0, superstruct_1.string)(),
});
//# sourceMappingURL=ClearProcessingRequest.js.map